if (!customElements.get('l20-active-imgs-tab')) {
  class L20ActiveImgsTab extends HTMLElement {
    connectedCallback() {
      this.initializeWhenReady();
    }

    disconnectedCallback() {
      window.clearTimeout(this.initializeTimer);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.removeEventListener('load', this.handleWindowLoad);

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initializeWhenReady(attempt = 0) {
      if (typeof window.Swiper !== 'undefined') {
        this.initialize();
        return;
      }

      if (attempt >= 100) return;
      this.initializeTimer = window.setTimeout(() => this.initializeWhenReady(attempt + 1), 50);
    }

    initialize() {
      if (this.swiper || typeof window.Swiper === 'undefined') return;

      const slider = this.querySelector('[data-imgs-tab-swiper]');
      const previousButton = this.querySelector('[data-imgs-tab-previous]');
      const nextButton = this.querySelector('[data-imgs-tab-next]');
      const slideCount = Number.parseInt(this.dataset.slideCount, 10) || 0;

      if (!slider || slideCount === 0) return;

      const desktopSlides = Number.parseFloat(this.dataset.desktopSlides) || 2.5;
      const mobileSlides = Number.parseFloat(this.dataset.mobileSlides) || 1.5;
      const desktopSpace = Number.parseInt(this.dataset.desktopSpace, 10) || 54;
      const mobileSpace = Number.parseInt(this.dataset.mobileSpace, 10) || 12;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const canLoop = slideCount > Math.ceil(Math.max(desktopSlides, mobileSlides));

      this.swiper = new window.Swiper(slider, {
        slidesPerView: mobileSlides,
        slidesPerGroup: 1,
        spaceBetween: mobileSpace,
        centeredSlides: false,
        loop: canLoop,
        rewind: !canLoop && slideCount > 1,
        watchOverflow: true,
        grabCursor: slideCount > 1,
        slideToClickedSlide: slideCount > 1,
        speed: reducedMotion ? 0 : 450,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: { prevEl: previousButton, nextEl: nextButton },
        a11y: {
          enabled: true,
          containerMessage: slider.getAttribute('aria-label') || 'Image carousel',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
          prevSlideMessage: 'Previous image',
          nextSlideMessage: 'Next image',
        },
        breakpoints: {
          750: {
            slidesPerView: desktopSlides,
            spaceBetween: desktopSpace,
            centeredSlides: false,
          },
        },
      });

      this.handleWindowLoad = () => {
        if (this.swiper) this.swiper.update();
      };

      requestAnimationFrame(() => {
        if (this.swiper) this.swiper.update();
      });
      window.addEventListener('load', this.handleWindowLoad, { once: true });

      this.handleBlockSelect = (event) => {
        const selectedSlide = event.target.closest('.l20-active-imgs-tab__slide');
        if (!selectedSlide || !this.contains(selectedSlide) || !this.swiper) return;

        const slideIndex = Number.parseInt(selectedSlide.dataset.slideIndex, 10);
        if (Number.isNaN(slideIndex)) return;

        if (this.swiper.params.loop) {
          this.swiper.slideToLoop(slideIndex, 0);
        } else {
          this.swiper.slideTo(slideIndex, 0);
        }
      };

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  customElements.define('l20-active-imgs-tab', L20ActiveImgsTab);
}
